var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap -mx-1"},_vm._l((10),function(n,index){return _c('div',{key:index,staticClass:"w-1/5 p-1"},[_c('vue-button',{staticClass:"w-full btn btn-primary btn-outline",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('input', index)}}},[_vm._v(_vm._s(index))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }